<template>
  <span class="table-info-w">
    <!-- 项目信息 -->
    <table border="0" cellspacing="10">
      <tr>
        <!-- 注意该rowspan="" -->
        <td rowspan="20" class="table_title" style="width: 85px">转出信息</td>
        <td class="w_td font_w_bold">项目名称</td>
        <td class="td_val_2 text_left">
          {{ projectInfo.title }}
        </td>
        <td class="font_w_bold">项目编号</td>
        <td class="td_val_2 text_left">{{ projectInfo.projectNo }}</td>
      </tr>
      <tr>
        <td class="font_w_bold">交易方式</td>
        <td class="max_w_107 text_left">
          {{ tradeModeKey[projectInfo.tradeMode] }}
        </td>
        <td class="font_w_bold">招标类型</td>
        <td class="td_val_2 text_left">
          {{ biddingTypeKey[projectInfo.biddingType] }}
        </td>
      </tr>
      <tr>
        <td class="font_w_bold">项目周期</td>
        <td class="text_left">
          {{ projectInfo.deadline
          }}<span v-if="projectInfo.deadlineUnit === 1">个</span
          >{{ deadlineUnitKey[projectInfo.deadlineUnit] }}
        </td>
        <td class="font_w_bold">预算金额</td>
        <td class="text_left">
          {{ projectInfo.price }}{{ projectInfo.priceUnitDesc
          }}<span v-if="projectInfo.priceUnit === 'zongjia' && isNotSmallmicro"
            >({{ priceUnitKey[projectInfo.priceUnit] }})</span
          >
        </td>
      </tr>
      <tr>
        <td class="font_w_bold">所在区域</td>
        <td class="text_left" colspan="3">
          {{ projectInfo.area }}
        </td>
      </tr>
      <tr>
        <td class="font_w_bold">详细地址</td>
        <td class="text_left" colspan="3">
          {{ projectInfo.address }}
        </td>
      </tr>
      <tr>
        <td class="font_w_bold">付款方式</td>
        <td class="text_left">
          {{ paymentModeKey[projectInfo.paymentMode] }}
        </td>
        <td class="font_w_bold">资金性质</td>
        <td class="text_left">
          {{ capitalPropertyKey[projectInfo.capitalProperty] }}
        </td>
      </tr>
      <tr>
        <td class="font_w_bold">资金来源</td>
        <td class="text_left" colspan="3">
          {{ capitalSourceKey[projectInfo.capitalSource] }}
        </td>
      </tr>
      <tr>
        <td class="font_w_bold">其他说明</td>
        <td colspan="3" class="text_left">
          <div v-html="remarkHandle"></div>
        </td>
      </tr>

      <tr>
        <!-- 注意该rowspan="" -->
        <td class="w_td font_w_bold">投标方条件</td>
        <td class="text_left" colspan="3">
          <span style="white-space: pre-line">{{ projectInfo.term }}</span>
        </td>
      </tr>
      <tr>
        <td class="font_w_bold">项目描述</td>
        <td class="text_left" colspan="3">{{ projectInfo.describe }}</td>
      </tr>

      <tr v-if="isAuction">
        <!-- <td rowspan="20" class="table_title" style="width: 85px">
                    竞价规则
                  </td> -->
        <td class="w_td font_w_bold">是否缴纳交易保证金</td>
        <td class="max_w_107 text_left">
          {{ whether[itemDetail.deposit] }}
        </td>
        <td class="w_td font_w_bold">交易保证金</td>
        <td class="max_w_107 text_left">{{ itemDetail.margin || 0 }}元</td>
      </tr>
      <tr v-if="isAuction">
        <td class="font_w_bold">竞价方式</td>
        <td class="max_w_107 text_left">
          {{ auctionModeKey[itemDetail.auctionMode] }}
        </td>
        <td class="font_w_bold">竞价幅度</td>
        <td class="max_w_107 text_left">
          {{ itemDetail.auctionRange || 0 }}元
        </td>
      </tr>
      <tr v-if="isAuction">
        <td class="font_w_bold">出价次数</td>
        <td class="max_w_107 text_left">
          {{ bidCountKey[itemDetail.bidCount] }}
        </td>
        <td class="font_w_bold">竞价方向</td>
        <td class="max_w_107 text_left">
          {{ directionKey[itemDetail.direction] }}
        </td>
      </tr>
      <tr v-if="isAuction">
        <td class="font_w_bold">是否延时</td>
        <td class="max_w_107 text_left">
          {{ whether[itemDetail.delay] }}
        </td>
        <td class="font_w_bold">延时周期</td>
        <td class="max_w_107 text_left">
          {{ itemDetail.delayedMinute }}分钟/次
        </td>
      </tr>
      <tr v-if="isAuction">
        <td class="font_w_bold">最大延时次数</td>
        <td colspan="3" class="text_left">{{ itemDetail.delayedCnt }}次</td>
      </tr>
      <tr v-if="isAuction">
        <td class="font_w_bold">报名开始时间</td>
        <td class="max_w_107 text_left">
          {{ itemDetail.applyStartTime }}
        </td>
        <td class="font_w_bold">报名结束时间</td>
        <td class="max_w_107 text_left">
          {{ itemDetail.applyEndTime }}
        </td>
      </tr>
      <tr v-if="isAuction">
        <td class="font_w_bold">竞价开始时间</td>
        <td class="max_w_107 text_left">
          {{ itemDetail.auctionStartTime }}
        </td>
        <td class="font_w_bold">竞价结束时间</td>
        <td class="max_w_107 text_left">
          {{ itemDetail.auctionEndTime }}
        </td>
      </tr>
    </table>
  </span>
</template>

<script>
import { mapGetters, mapMutations, mapActions } from "vuex";
import { TradeMode } from "@/enums";
import TradeKindEnum from "@/enums/tradeKindEnum";
export default {
  props: {
    itemDetail: {
      type: Object,
      default: () => {},
    },
  },
  computed: {
    ...mapGetters([
      "deadlineUnitKey",
      "priceUnitKey",
      "tradeModeKey",
      "biddingTypeKey",
      "paymentModeKey",
      "capitalPropertyKey",
      "capitalSourceKey",
      "whether",
      "auctionModeKey",
      "bidCountKey",
      "directionKey",
    ]),
    projectInfo() {
      return this.itemDetail.project;
    },
    // 是竞价项目
    isAuction() {
      return this.projectInfo.tradeMode === TradeMode.AUCTION;
    },
    // 是否小微
    isNotSmallmicro() {
      return this.projectInfo.tradeKind !== TradeKindEnum.SMALLMICRO;
    },
    remarkHandle() {
      if (
        this.projectInfo.remark &&
        typeof this.projectInfo.remark === "string"
      ) {
        return this.projectInfo.remark.replace(/\n/g, "<br>");
      }
      return this.projectInfo.remark;
    },
    transfereeConditionHandle() {
      if (
        this.projectInfo.transfereeCondition &&
        typeof this.projectInfo.transfereeCondition === "string"
      ) {
        return this.projectInfo.transfereeCondition.replace(/\n/g, "<br>");
      }
      return this.projectInfo.transfereeCondition;
    },
  },
};
</script>

<style lang="scss" scoped>
.table-info-w {
  & > table {
    width: 100%;
    // border-color: #e6e6e6;

    //标准单元格宽度
    .w_td {
      width: 147px;
      white-space: nowrap;
    }
    //最大单元格宽度164
    .max_w_164 {
      max-width: 164px;
    }
    //最大单元格宽度210
    .max_w_210 {
      max-width: 210px;
    }
    .td_val_2 {
      width: 250px;
    }
    //最大单元格宽度696
    .max_w_696 {
      max-width: 696px;
    }
    &:last-of-type {
      border-bottom: none !important;
    }
    tr {
      &:first-child {
        td {
          &:first-child {
            border-left: 1px solid #e6e6e6;
          }
        }
      }
      td {
        word-break: break-word;
        box-sizing: border-box;
        padding: 20px;
        border-top: 1px solid #e6e6e6;
        border-right: 1px solid #e6e6e6;
      }
    }
    .table_title {
      padding: 0 18px;
      box-sizing: border-box;
      width: 82px;
      line-height: 34px;
      font-size: 18px;
      background: #eaf2fa;
    }
  }
}
</style>